import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";
import {SLAReport, SLAReportService, SLAReportViewGroup} from "@/lib/queries/reports.ts";
import {SLAReportServiceTableRow} from "@/pages/reports/sla/details/SLAReportServiceTableRow.tsx";
import {SLAReportServiceTableRowGroup} from "@/pages/reports/sla/details/SLAReportServiceTableRowGroup.tsx";

interface SLAReportServicesTableProps {
  className?: string;
  items: SLAReportService[];
  groups: SLAReportViewGroup[];
  title: string;
  report: SLAReport;
}

export const SLAReportServicesTable = ({className, title, report, items, groups}: SLAReportServicesTableProps) => {
  const hasContent = groups.length + items.length > 0;
  return (
    <div className={className}>
      <div className="col mb-4 fw-semibold fs-4">{title}</div>
      <div style={{overflowX: "auto", WebkitOverflowScrolling: "touch"}}>
        <table className="table table-sm border" style={{minWidth: "800px"}}>
          <thead>
            <tr>
              <th>Name</th>
              {report.show_uptime_sla && (
                <th className="text-center">
                  Target SLA{" "}
                  <TooltipIconRA
                    iconProps={{
                      display: "inline",
                      removeDivDimensions: true,
                    }}
                    className="ms-1"
                    title="The Target SLA percentage value defined on the Check."
                  />
                </th>
              )}
              <th className="text-center">Uptime</th>
              <th className="text-center">Outages</th>
              <th className="text-center">Downtime</th>
              <th className="text-center">Avg. Response Time</th>
              <th className="w-10"></th>
            </tr>
          </thead>
          <tbody>
            {groups.map((group) => (
              <SLAReportServiceTableRowGroup key={`group-${group.group.id}`} group={group} report={report} />
            ))}
            {items.map((item) => (
              <SLAReportServiceTableRow key={`service-${item.service_id}`} item={item} report={report} />
            ))}
            {!hasContent && (
              <tr className="p-3">
                <td colSpan={4}>No Checks were recorded below their Target SLA in the selected period. </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
